export enum StyleWeighmentEnum{
    NWNC = 'NWMC',
    FWNC = 'FWNC',
    FWFC = 'FWFC',
    NWFC = 'NWFC'
}